import { render, staticRenderFns } from "./RolesList.vue?vue&type=template&id=4b9a6ddb&scoped=true"
import script from "./RolesList.vue?vue&type=script&lang=js"
export * from "./RolesList.vue?vue&type=script&lang=js"
import style0 from "./RolesList.vue?vue&type=style&index=0&id=4b9a6ddb&prod&scoped=true&lang=css"
import style1 from "./RolesList.vue?vue&type=style&index=1&id=4b9a6ddb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9a6ddb",
  null
  
)

export default component.exports